import React from 'react'

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import women from "../images/BEST SAREE MAIN PAGE.jpg";

import mens from "../images/Men Home.jpg";
import accessories from "../images/troli bag.jpg";

import kids from "../images/kids wear.jpg";
import "./Products.css";

import { Link } from 'react-router-dom';


function Products() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  return (
    <div>


      <div className="animat">
        <Slider {...settings}>

        
            <div className="card mb-4 border-White box ">
              <a href='womens-wear'>
                <img src={women} className="card-img-top" alt="Womens_wear"/>
              </a>
              <div className="card-body">

                <p style={{ color: "maroon" }} className="card-text mb-0">Womens</p>
                <a href='womens-wear'>
                  <p className="card-text mb-0"> <small> <span>Explore<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                  </svg></span></small></p> </a>
              </div>
            

          </div>

          <div>
            <div className="card mb-4 border-White box ">
              <a href='mens-wear'>
                <img src={mens} className="card-img-top" alt="Balaji Saree" />
              </a>
              <div className="card-body">

                <p style={{ color: "maroon" }} className="card-text mb-0">Mens</p>
                <a href='mens-wear'>
                  <p className="card-text"> <small> <span>Explore<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                  </svg></span></small></p> </a>
              </div>
            </div>
          </div>

          <div>
            <div className="card mb-4 border-White box ">
              <Link to="Kidsware">
                <img src={kids} className="card-img-top" alt="Balaji Saree" />
              </Link>
              <div className="card-body">

                <p style={{ color: "maroon" }} className="card-text mb-0">Kids</p>
                <Link to="Kidsware">
                  <p className="card-text"> <small> <span>Explore<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                  </svg></span></small></p> </Link>
              </div>
            </div>
          </div>

          <div>
            <div className="card mb-4 border-White box ">
              <Link to="/accessories">
                <img src={accessories} className="card-img-top" alt="accessories"/>
              </Link>
              <div className="card-body">

                <p style={{ color: "maroon" }} className="card-text mb-0"><small>Accessories</small></p>
                <Link to="/accessories">
                  <p className="card-text"> <small> <span>Explore<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                  </svg></span></small></p> </Link>
              </div>
            </div>
          </div>






















        </Slider>
      </div>

    </div>
  )
}



export default Products
